<template>
    <div class="page-tool">
        <div @click="handleBack"><img src="../../assets/img/return.png"></div>
<!--        <div><img src="../../assets/img/message.png"></div>-->
        <div @click="handleFeedback"><img src="../../assets/img/service.png"></div>
        <div @click="handleManager"><img src="../../assets/img/subscription.png"></div>
    </div>
</template>

<script>
// import { useRoute } from "vue-router"
import { useRouter } from "vue-router"

export default {
    name: "pageTool",
    setup() {
        const router = useRouter()
        const handleBack = () => {
            router.back(-1)
        }
        const handleFeedback = () => {
            router.push({ name: 'Feedback'})
        }
        const handleManager = () => {
            router.push({ name: 'subscription'})
        }
        return {
            handleBack,
            handleFeedback,
            handleManager
        }
    }
}
</script>

<style scoped lang="stylus">
    .page-tool {
        position fixed
        top 70%
        z-index 1
        right 1px
    }
    .page-tool div {
        width 50px
        height 50px
        line-height 35px
        text-align center
        border-radius 50%
        margin-bottom 5px
    }
    .page-tool div img{
        width 100%
        height 100%
    }
</style>